/**
 * Utility functions for handling slug-based URLs
 */

// UUID regex pattern to detect if a parameter is a UUID
const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

/**
 * Check if a string is a valid UUID
 */
export const isUUID = (str: string): boolean => {
  return UUID_REGEX.test(str);
};

/**
 * Create a database query condition for tools that can match by slug or ID
 */
export const createToolQuery = (toolParam: string) => {
  return isUUID(toolParam) 
    ? { column: 'id', value: toolParam }
    : { column: 'slug', value: toolParam };
};

/**
 * Create a database query condition for survey templates that can match by slug or ID
 */
export const createTemplateQuery = (templateParam: string) => {
  return isUUID(templateParam) 
    ? { column: 'id', value: templateParam }
    : { column: 'slug', value: templateParam };
};

/**
 * Get the appropriate URL parameter for a tool (prefer slug over ID)
 */
export const getToolUrlParam = (tool: { slug?: string; id: string }): string => {
  return tool.slug || tool.id;
};

/**
 * Get the appropriate URL parameter for a survey template (prefer slug over ID)
 */
export const getTemplateUrlParam = (template: { slug?: string; id: string }): string => {
  return template.slug || template.id;
};